// The dashboard greeting follows the clock of the person reading it (#307, KP-6.3).
// Their saved timezone decides the hour; without one, the device's own clock does.

export const GREETING = {
  MORNING: 'Good morning',
  AFTERNOON: 'Good afternoon',
  EVENING: 'Good evening',
};

// The hour (0-23) that `date` shows in `timeZone`. An unknown zone falls back to the device.
function hourIn(date, timeZone) {
  const read = (tz) => {
    const parts = new Intl.DateTimeFormat('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: tz }).formatToParts(date);
    return Number(parts.find((p) => p.type === 'hour').value) % 24;
  };
  if (!timeZone) return read(undefined);
  try {
    return read(timeZone);
  } catch {
    return read(undefined);
  }
}

// Morning runs 05:00-11:59, afternoon 12:00-17:59, evening the rest of the day and night.
export function greetingFor(date = new Date(), timeZone) {
  const hour = hourIn(date, timeZone);
  if (hour >= 5 && hour < 12) return GREETING.MORNING;
  if (hour >= 12 && hour < 18) return GREETING.AFTERNOON;
  return GREETING.EVENING;
}
